import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { activeRightSidebarAtom } from '@frontend/atoms';

import { fetchBadgeCount } from '../services';

type UseBadgeCountOptions = {
  grouped?: boolean;
  ignoreViewingSuppression?: boolean;
};

export function useBadgeCount({
  grouped = false,
  ignoreViewingSuppression = false,
}: UseBadgeCountOptions = {}) {
  const activeRightSidebar = useAtomValue(activeRightSidebarAtom);
  const location = useLocation();
  // Hide the badge while the user is actively viewing notifications — bell, nav,
  // and favicon all defer to this so they stay consistent.
  const isViewingNotifications =
    activeRightSidebar === 'notifications' || location.pathname.includes('/notifications');

  const query = useQuery({
    queryKey: ['notifications', 'badge-count', { grouped }],
    queryFn: async () => {
      const data = await fetchBadgeCount(grouped);
      return data.count;
    },
    refetchInterval: 60_000,
  });

  if (isViewingNotifications && !ignoreViewingSuppression) {
    return { ...query, data: 0 };
  }
  return query;
}
